export default "__VITE_ASSET__Bt0iTRlu__"